"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Characters = void 0;
var rich_utils_1 = require("../../core/model/rich-utils");
var Characters = (function () {
    function Characters() {
    }
    Characters.PageBreak = rich_utils_1.RichUtils.specialCharacters.PageBreak;
    Characters.LineBreak = rich_utils_1.RichUtils.specialCharacters.LineBreak;
    Characters.ParagraphBreak = rich_utils_1.RichUtils.specialCharacters.ParagraphMark;
    return Characters;
}());
exports.Characters = Characters;
